<template>
    <!-- 订单赠送商品选择组件 -->
    <div class="give-selector-container">
        <a-table
        bordered
        :columns="columns"
        :rowSelection="isSelected ? {type: 'checkbox', onChange: change, getCheckboxProps: setCheckboxProps, selectedRowKeys: selectedRowKeys} : null"
        :rowKey="(item, index) => item.key"
        :dataSource="dataSource"
        :pagination="false"
        :scroll="{y: 250}"
        >
            <template slot="goodsName" slot-scope="goodsName, row, index">
                {{goodsName || row.name}}
            </template>
            <template slot="goodsType" slot-scope="key, row, index">
                <span v-if="!isNewActivity">{{["", "票券","课程","零售","餐品", "储值", "售后", "优惠券", "积分"][key || row.type]}}</span>
                <span v-else>{{["", "票券", "优惠券", "储值卡", "积分"][key || row.type]}}</span>
            </template>
            <template slot="giveOwner" slot-scope="giveOwner, row, index">
                {{owner}}
            </template>
            <template slot="ticketState" slot-scope="key, row, index">
                {{key || "-"}}
            </template>
            <template slot="goodsNum" slot-scope="key, row, index">
                {{key || row.number}}
            </template>
        </a-table>
    </div>
</template>

<script>
    export default {
        name: "member-order-give-selector",
        zh: "订单赠送商品选择组件",
        props: {
            type: {
                type: String,
                default: 'forbidden'
            },
            isForbidden: {
                type: Boolean,
                default: true
            },
            ticketGiftDetail: {
                type: Object,
                default: () => {}
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isSelected: {
                type: Boolean,
                default: true
            },
            ticketGivenId: {
                type: String,
                default: "",
            },
            owner: {
                type: String,
                default: "",
            },
            isNewActivity: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                columns: [],
                selectedRows: [],
                selectedRowKeys: [],
                dataSource: [],
            }
        },
        computed: {},
        watch: {
            ticketGiftDetail: {
                handler: function(val, oval) {
                    if (val) {
                        this.dataSource = val.gifts || [];
                        this.upgradeChecked(val);
                    }
                },
                immediate: true
            },
        },
        // 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
        methods: {
            /**
             * @getUserTicketGiveInfoVo 获取用户票券赠品的信息
             */
            getUserTicketGiveInfoVo() {
                return new Promise((resolve, reject) => {
                    this.$api.order.getGivedDetail({
                        body: {
                            isGiftBonus: true,
                            mainGoodId: this.ticketGivenId || this.$route.query.id,
                        }
                    }).then(res => {
                        let gifts = [];
                        for (const i in res) {
                            if (Object.hasOwnProperty.call(res, i) && (res[i] instanceof Array)) {
                                const element = res[i] || [];
                                gifts.push(...element)
                            }
                        }
                        this.dataSource = gifts;
                        resolve(gifts);
                        gifts.forEach( (el, key) => {
                            el.key = key;
                        })
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                        this.$nextTick(() => {
                            let { type, isForbidden } = this;
                            //用途，票券禁用/解禁
                            if (type === 'forbidden' && isForbidden) {
                                this.forbiddenChecked();
                            } else if(type === 'refund') {
                                this.refundChecked();
                            } else if (type === 'changeOwner') {
                                this.changeOwnerChecked();
                            } else if (type === 'upgrade') {
                                this.upgradeChecked();
                            };
                        })
                    });
                })
            },
            change(selectedRowKeys, selectedRows) {
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
            },
            setCheckboxProps(record) {
                // 赠品类型 1票券 2优惠券 3储值卡 5积分
                // 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
                let { goodsType, statusStr } = record;
                let disabled;
                if (this.type === 'upgrade' && this.disabled) {
                    if (goodsType === 1) {
                        disabled = !Boolean(['已生效','已过期', "已锁定", "已冻结", "已禁用"].find(item => item === statusStr));
                    } else if(goodsType === 7) {
                        disabled = !Boolean(['未使用', "已过期", '已锁定', '已禁用'].find(item => item === statusStr));
                    } else {
                        disabled = false;
                    }
                } else if (this.type === 'changeOwner') {
                    if (goodsType === 1) {
                        disabled = !Boolean(['已生效'].find(item => item === statusStr));
                    } else if(goodsType === 7) {
                        disabled = !Boolean(['未使用'].find(item => item === statusStr));
                    } else if(goodsType === 5 || goodsType === 8) {
                        disabled = true;
                    } else {
                        disabled = false;
                    }
                } else if ((this.type === 'forbidden' && !this.isForbidden)) {
                    if (goodsType === 1) {
                        disabled = !Boolean(['已禁用'].find(item => item === statusStr));
                    } else if(goodsType === 7) {
                        disabled = !Boolean(['已禁用'].find(item => item === statusStr));
                    } else {
                        disabled = false;
                    }
                }
                return {
                    props: {
                        disabled: this.disabled || disabled
                    }
                }
            },
            /**
             * @forbiddenChecked 票券禁用操作默认选择
             */
            forbiddenChecked(val) {
                let selectedRows = [];
                let selectedRowKeys = [];
                if (this.isForbidden) {
                    //禁用
                    this.dataSource.forEach((item, index) => {
                        let flag;
                        let { goodsType, statusStr } = item;
                        // 赠品类型 1票券 2优惠券 3储值卡 5积分
                        // 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
                        if (goodsType === 1) {
                            flag = Boolean(['已生效','已过期', "已锁定", "已冻结"].find(item => item === statusStr));
                        } else if(goodsType === 7) {
                            flag = Boolean(['未使用', '已过期', '已锁定'].find(item => item === statusStr));
                        } else {
                            flag = true;
                        }
                        if (flag) {
                            selectedRowKeys.push(index);
                            selectedRows.push(item);
                        }
                    });
                } else {
                    // 取消禁用
                    this.dataSource.forEach((item, index) => {
                        let flag;
                        let { goodsType, statusStr } = item;
                        // 赠品类型 1票券 2优惠券 3储值卡 5积分
                        // 赠品类型 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
                        // 票券状态: 1 待支付 2 支付失败 3 已支付 4 已过期 5 已失效 6 退款中 7 已退款 8 退款失败 9 已禁用 10已冻结
                        // 优惠券状态: 0 未领取 1 未使用 2 已使用 3 领取失败 4 已失效 5 已禁用
                        if (goodsType === 1) {
                            flag = Boolean(["已禁用"].find(item => item === statusStr));
                        } else if(goodsType === 7) {
                            flag = Boolean(["已禁用"].find(item => item === statusStr));
                        } else {
                            flag = true;
                        }
                        if (flag) {
                            selectedRowKeys.push(index);
                            selectedRows.push(item);
                        }
                    });
                }
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
            },
            /**
             * @refundChecked 票券退款操作默认选择
             */
            refundChecked(val) {
                let selectedRows = [];
                let selectedRowKeys = [];
                this.dataSource.forEach((item, index) => {
                    let flag;
                    let { goodsType, statusStr } = item;
                    // 赠品类型 1票券 2优惠券 3储值卡 5积分
                    // 赠品类型 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
                    // 票券状态: 1 待支付 2 支付失败 3 已支付 4 已过期 5 已失效 6 退款中 7 已退款 8 退款失败 9 已禁用 10已冻结
                    // 优惠券状态: 0 未领取 1 未使用 2 已使用 3 领取失败 4 已失效 5 已禁用
                    if (goodsType === 1) {
                        flag = Boolean(['已生效','已过期', '已禁用', '已冻结', "已锁定"].find(item => item === statusStr));
                    } else if(goodsType === 7) {
                        flag = Boolean(['未使用', "已过期", '已锁定', '已禁用'].find(item => item === statusStr));
                    } else {
                        flag = true;
                    }
                    if (flag) {
                        selectedRowKeys.push(index);
                        selectedRows.push(item);
                    }
                });
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
            },
            /**
             * @upgradeChecked 票券升级操作默认选择
             */
            upgradeChecked(val) {
                if (this.disabled) {
                    this.refundChecked(val);
                    return false;
                }
                let selectedRows = [];
                let selectedRowKeys = [];
                this.dataSource.forEach((item, index) => {
                    selectedRowKeys.push(index);
                    selectedRows.push(item);
                });
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
            },
            /**
             * @changeOwnerChecked 持有者更改操作默认选择
             */
            changeOwnerChecked(val) {
                let selectedRows = [];
                let selectedRowKeys = [];
                this.dataSource.forEach((item, index) => {
                    let { goodsType, statusStr } = item;
                    let flag;
                    // 1票券 2优惠券 3储值卡 5积分
                    // 1票券 2课程 3零售 4餐品 5储值 6售后 7优惠券 8积分
                    if (goodsType === 1) {
                        flag = Boolean(['已生效'].find(item => item === statusStr));
                    } else if(goodsType === 7) {
                        flag = Boolean(['未使用'].find(item => item === statusStr));
                    } else {
                        flag = false;
                    }
                    if (flag) {
                        selectedRowKeys.push(index);
                        selectedRows.push(item);
                    }
                });
                this.selectedRows = selectedRows;
                this.selectedRowKeys = selectedRowKeys;
            },
            getSelectedRowKeys() {
                return this.selectedRowKeys;
            },
            getSelectedRows() {
                return this.selectedRows;
            }
        },
        beforeCreate() {

        },
        created() {
            let columns = [
                {
                    title: '赠送商品名称',
                    dataIndex: 'goodsName',
                    scopedSlots: { customRender: "goodsName" },
                },
                {
                    title: '赠送商品类型',
                    dataIndex: 'goodsType',
                    scopedSlots: { customRender: "goodsType" },
                    width: 100
                },
                {
                    title: '赠送数量',
                    dataIndex: 'goodsNum',
                    width: 100,
                    scopedSlots: { customRender: "goodsNum" },
                }
            ];
            if (this.type === 'forbidden' || this.type === 'changeOwner') {
                columns.push( {
                    title: '状态',
                    dataIndex: 'statusStr',
                    scopedSlots: { customRender: "ticketState" },
                    width: 100
                });
            };
            if (this.type != "repairCard" && this.type != "upgradeNew") {
                columns.push( {
                    title: '持有者账号',
                    dataIndex: 'giveOwner',
                    width: 100,
                    scopedSlots: { customRender: "giveOwner" },
                });
            }

            this.columns = columns;
        },
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
    .give-selector-container {
        background-color: #fff;
    }
</style>
